<template>
  <div class="reportcontain">
    <div style="text-align: right; margin-bottom: 10px">
      <el-button
        style="float: left"
        :disabled="!$route.query.id"
        @click="back"
        size="mini"
        plain
        type="primary"
        >返回列表</el-button
      >
      <el-button type="primary" v-print="printObj">生成PDF</el-button>
      <el-button type="primary" @click="getJpg">保存报告图片</el-button>
      <el-button type="primary" @click="changeReport(descriptionsData)"
        >修改报告内容</el-button
      >
    </div>
    <div
      style="
        width: 60%;
        display: flex;
        flex-direction: column;
        padding-left: 20%;
      "
    >
      <div id="demo" ref="imageDom">
        <div
          v-if="descriptionsData.projectId == 1 && this.$route.query.type == 2"
          style="display: flex; justify-content: center; flex-direction: column"
        >
          <img src="../../../assets/bre1.png" />
        </div>
        <div
          v-if="descriptionsData.projectId == 2 && this.$route.query.type == 2"
          style="display: flex; justify-content: center; flex-direction: column"
        >
          <img src="../../../assets/pc1.png" />
        </div>
        <el-descriptions
          class="margin-top"
          direction="vertical"
          :column="1"
          border
        >
          <el-descriptions-item>
            <!-- <template slot="label">
              检测报告
            </template> -->
            <div style="border-bottom: 1px solid #f5f5f5">
              <h2
                style="
                  text-align: center;
                  color: #000;
                  display: flex;
                  justify-content: space-evenly;
                  align-items: center;
                "
              >
                <img
                  v-if="descriptionsData.templateTitleLogo != 0"
                  :src="descriptionsData.templateTitleLogo"
                  style="width: 55px; height: 55px"
                />
                <p>
                  {{ descriptionsData.title }}
                </p>
                <p v-if="descriptionsData.templateTitleLogo != 0"></p>
              </h2>
              <!-- <span v-if="descriptionsData.placeId != 28" style="display:block;text-align: center;">
                By 精康科技
              </span> -->
              <p class="title">
                <span> 姓名：{{ descriptionsData.name }} </span>
                <span> 性别：{{ descriptionsData.gender }} </span>
                <span> 年龄：{{ descriptionsData.age }} </span>
              </p>
              <p class="title2">
                <span>
                  检查项目：<span v-if="descriptionsData.projectId == 1"
                    >乳腺</span
                  ><span v-if="descriptionsData.projectId == 2">甲状腺</span>
                </span>
                <span>
                  检查时间：{{
                    descriptionsData.created
                      | formatDateHM(descriptionsData.created)
                  }}
                </span>
              </p>
              <p v-if="this.$route.query.type == 1">
                <span>{{ descriptionsData.templateTips }}</span
                >{{ descriptionsData.des }}
              </p>
            </div>

            <div>
              <img
                v-for="(item, index) in descriptionsData.uploadPath"
                :key="index"
                :src="item"
                alt=""
                style="width: 300px; height: 200px; margin: 0 10px"
              />
              <!-- <p v-if="item.result == 0.5 && item.imagesList.length > 0">
                <img
                  v-for="ite in item.imagesList"
                  :key="ite"
                  :src="ite"
                  alt=""
                  style="width:300px;height:200px;margin:0 10px"
                />
              </p>
              <p v-if="item.result == 1 && item.imagesList.length > 0">
                <img
                  v-for="ite in item.imagesList"
                  :key="ite"
                  :src="ite"
                  alt=""
                  style="width:300px;height:200px;margin:0 10px"
                />
              </p>
              <p v-if="item.result == 0.9 && item.imagesList.length > 0">
                <img
                  v-for="ite in item.imagesList"
                  :key="ite"
                  :src="ite"
                  alt=""
                  style="width:300px;height:200px;margin:0 10px"
                />
              </p>
              <p v-if="item.result == 0.8 && item.imagesList.length > 0">
                <img
                  v-for="ite in item.imagesList"
                  :key="ite"
                  :src="ite"
                  alt=""
                  style="width:300px;height:200px;margin:0 10px"
                />
              </p> -->
            </div>
            <span style="color: #000; font-size: 20px; display: block">
              <span style="font-weight: 700"> 超声所见：</span>
              <p style="text-indent: 2px" v-if="descriptionsData.description">
                {{ descriptionsData.description[0] }}
              </p>
            </span>
            <div
              style="color: #000; font-size: 20px; display: block"
              v-if="this.$route.query.type == 1"
            >
              <span
                style="font-weight: 700; display: block; margin-bottom: 10px"
              >
                超声提示：</span
              >
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
              >
                {{ descriptionsData.description[1] }}
              </span>
            </div>
            <span
              style="color: #000; font-size: 20px; display: block"
              v-if="this.$route.query.type == 2"
            >
              <span
                style="font-weight: 700; display: block; margin-bottom: 10px"
              >
                超声提示：</span
              >
              <img
                src="../../../assets/Group137.png"
                width="90px"
                v-if="descriptionsData.resultStatus == 3"
              />
              <img
                src="../../../assets/Group138.png"
                width="90px"
                v-if="descriptionsData.resultStatus == 2"
              />
              <img
                src="../../../assets/Group140.png"
                width="90px"
                v-if="descriptionsData.resultStatus == 1"
              />
              <img
                src="../../../assets/Group139.png"
                width="90px"
                v-if="descriptionsData.resultStatus == 0"
              />
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
                v-if="descriptionsData.risk == 0"
              >
                <!-- {{descriptionsData.description[1]}} -->
                目前检查结果表明恶性风险极低。建议您继续保持健康的生活方式并定期进行体检。
              </span>
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
                v-if="descriptionsData.risk == 1"
              >
                <!-- {{descriptionsData.description[1]}} -->
                目前检查结果表明恶性风险低。建议您继续保持健康的生活方式并定期进行体检。
              </span>
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
                v-if="descriptionsData.risk == 2"
              >
                <!-- {{descriptionsData.description[1]}} -->
                目前检查结果表明中度恶性风险。建议您继续保持健康的生活方式并定期进行体检。
              </span>
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
                v-if="descriptionsData.risk == 3"
              >
                <!-- {{descriptionsData.description[1]}} -->
                检查结果表明存在高度恶性风险的结节，建议您进行定期复查，并按医生建议采取进一步检査或治疗。
              </span>
              <span
                style="text-indent: 2px; display: block; margin-bottom: 20px"
                v-if="descriptionsData.risk == 4"
              >
                <!-- {{descriptionsData.description[1]}} -->
                检查结果表明存在极高风险的恶性结节，强烈建议您尽快寻求医疗帮助进行进一步治疗。
              </span>
            </span>
          </el-descriptions-item>
          <el-descriptions-item>
            <div class="title">
              <div>本报告单仅供临床参考</div>
              <div>
                报告日期：{{
                  descriptionsData.created
                    | formatDate(descriptionsData.created)
                }}
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <div
          style="display: flex; justify-content: center; flex-direction: column"
          v-if="descriptionsData.projectId == 1 && this.$route.query.type == 2"
        >
          <img src="../../../assets/bre3.png" />
          <img src="../../../assets/bre4.png" />
          <img src="../../../assets/bre5.png" />
          <img src="../../../assets/bre6.png" />
          <img src="../../../assets/bre7.png" />
          <img src="../../../assets/bre8.png" />
          <img src="../../../assets/bre9.png" />
        </div>
        <div
          style="display: flex; justify-content: center; flex-direction: column"
          v-if="descriptionsData.projectId == 2 && this.$route.query.type == 2"
        >
          <img src="../../../assets/pc3.png" />
          <img src="../../../assets/pc4.png" />
          <img src="../../../assets/pc5.png" />
          <img src="../../../assets/pc6.png" />
          <img src="../../../assets/pc7.png" />
          <img src="../../../assets/pc8.png" />
        </div>
      </div>
    </div>
    <div class="pdf">
      <pdf v-for="i in numPages" ref="pdfs" :src="src" :key="i" :page="i">
      </pdf>
    </div>
    <div class="demo-image__preview">
      <el-image
        class="my-img"
        style="width: 100px; height: 100px"
        :src="url"
        :preview-src-list="imgUrl"
        ref="preview"
      >
      </el-image>
    </div>
    <div>
      <el-dialog
        title="修改报告"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
      >
        <el-form
          label-position="right"
          label-width="80px"
          :model="formLabelAlign"
        >
          <el-form-item label="姓名">
            <el-input v-model="formLabelAlign.name"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio v-model="formLabelAlign.gender" :label="0">男</el-radio>
            <el-radio v-model="formLabelAlign.gender" :label="1">女</el-radio>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input v-model="formLabelAlign.age"></el-input>
          </el-form-item>
          <el-form-item label="风险程度">
            <el-select v-model="formLabelAlign.risk" placeholder="请选择">
              <el-option
                v-for="item in resultsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择模板">
            <el-select
              v-model="formLabelAlign.templateType"
              filterable
              clearable
              placeholder="请选择模板"
              @change="selectChange"
              style="margin-right: 10px"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.templateName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超声所见" v-if="formLabelAlign.description">
            <el-input
              autosize
              type="textarea"
              v-model="formLabelAlign.description[0]"
            ></el-input>
          </el-form-item>
          <el-form-item label="超声提示" v-if="formLabelAlign.description">
            <el-input
              autosize
              type="textarea"
              v-model="formLabelAlign.description[1]"
            ></el-input>
          </el-form-item>
          <el-form-item label="超声提示">
            <el-upload
              action="#"
              list-type="picture-card"
              :file-list="formLabelAlign.fileList"
              :auto-upload="false"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmits">确认修改</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleImg">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import {
  getDetails,
  uploadReport,
  infoTemplate,
  detailTemplate,
} from "@/api/api";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      src: "",
      descriptionsData: {},
      printObj: {
        id: "demo",
        popTitle: "打印标题控制",
      },
      numPages: "",
      imgUrl: [],
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      imgPre: "",
      formLabelAlign: {},
      dialogVisible: false,
      dialogImageUrl: "",
      dialogVisibleImg: false,
      description: [],
      disabled: false,
      path: "",
      options: [],
      resultsList: [
        { value: 0, label: "正常，无风险" },
        { value: 1, label: "低风险" },
        { value: 2, label: "中风险" },
        { value: 3, label: "高风险" },
      ],
    };
  },
  computed: {
    preview() {
      const { previewSrcList } = this;
      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.imgPre) {
      this.imgPre.close();
    }
    next();
  },
  methods: {
    onSubmits() {
      let that = this;
      this.$confirm("是否确认修改该报告?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.onSubmit();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    selectChange(value) {
      console.log(value);
      this.formLabelAlign.description = [];
      if (value == 0) {
        this.formLabelAlign.description = this.descriptionsData.description;
      } else {
        detailTemplate({ id: value }).then((res) => {
          console.log(res.data);
          this.description[0] = res.data.templateResult;
          this.description[1] = res.data.templateInfo;
          this.formLabelAlign.description = this.description;
        });
      }
    },
    onSubmit() {
      let fromData = new FormData();
      console.log(this.formLabelAlign, "onSubmit");
      let uploadPath = "";
      let files = [];
      this.formLabelAlign.fileList.forEach((item) => {
        if (item.status == "success") {
          uploadPath += item.url + ",";
        } else {
          fromData.append("files", item.raw);
        }
      });
      if (this.formLabelAlign.age == null) {
        this.formLabelAlign.age = "";
      }
      console.log(uploadPath, this.path, files, "onSubmit");
      fromData.append(`desc`, this.formLabelAlign.description[0]);
      fromData.append(`descTip`, this.formLabelAlign.description[1]);
      fromData.append(`risk`, this.formLabelAlign.risk);
      fromData.append("id", this.formLabelAlign.id);
      fromData.append("name", this.formLabelAlign.name);
      fromData.append("gender", this.formLabelAlign.gender);
      fromData.append("age", this.formLabelAlign.age);
      fromData.append(`uploadPath`, uploadPath);
      fromData.append("path", this.path);
      console.log(fromData);
      uploadReport(fromData).then((res) => {
        console.log(res);
        if (res.code == 0) {
          let data = {
            id: this.$route.query.id,
            projectId: this.$route.query.projectId,
          };
          this.getDetail(data);
          this.dialogVisible = false;
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file);
      this.formLabelAlign.fileList = fileList;
      console.log(this.formLabelAlign.fileList, "handleRemove");
    },
    uploadFile() {},
    handleChange(file, fileList) {
      this.formLabelAlign.fileList = fileList;
      console.log(this.formLabelAlign.fileList, "handleChange");
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    handleClose(done) {
      this.$confirm("不保存修改并关闭？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dialogVisible = false;
        })
        .catch(() => {});
    },
    changeReport(row) {
      this.options = [
        {
          id: 0,
          templateName: "取消修改",
        },
      ];
      infoTemplate({ id: this.$route.query.projectId }).then((res) => {
        console.log(res, "项目模板信息");
        if (res.code == 0) {
          res.data.forEach((item) => {
            this.options.push(item);
          });
        }
      });
      this.dialogVisible = true;
      this.formLabelAlign = JSON.parse(JSON.stringify(row));
      if (this.formLabelAlign.gender == "男") {
        this.formLabelAlign.gender = 0;
      } else {
        this.formLabelAlign.gender = 1;
      }
    },
    back() {
      if (this.$route.query.type == 1) {
        this.$router.push({
          path: "/main/backstage",
        });
      } else if (this.$route.query.type == 2) {
        this.$router.push({
          path: "/main/vipreportList",
        });
      }
    },
    imgPreview(imgs, index) {
      this.imgPre = ImagePreview({
        images: imgs,
        loseable: true,
        startPosition: index,
        closeOnPopstate: true,
      });
    },
    getJpg() {
      this.imgUrl = [];
      //生成图片
      setTimeout(() => {
        window.pageYoffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        html2canvas(this.$refs.imageDom, {
          useCORS: true,
          scale: window.devicePixelRatio, //设置放大的倍数
          scrollY: 0,
          scrollX: 0,
          height: document.getElementById("demo").scrollHeight,
          windowHeight: document.getElementById("demo").scrollHeight,
        }).then((canvas) => {
          // 转成图片，生成图片地址
          // this.imgUrl.push(canvas.toDataURL("image/png")); //可将 canvas 转为 base64 格式
          // this.$refs.preview.showViewer = true;
          this.convertCanvasToImg(canvas);
        });
      }, 500);
    },
    // 转换图片格式
    convertCanvasToImg(canvas) {
      // canvas base64 转 blob
      var myBlob = this.dataURLtoBlob(canvas.toDataURL("img/jpg", 0.92));
      // blob转URL对象
      var myUrl = URL.createObjectURL(myBlob);
      // 创建a标签，下载图片
      this.downImg(myUrl);
    },

    //base64 转 blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //下载图片 filename是图片名称
    downImg(url) {
      // 创建a标签 并设置其相关属性，最后触发其点击事件
      let a = document.createElement("a");
      let clickEvent = document.createEvent("MouseEvents");
      a.setAttribute("href", url);
      a.setAttribute("download", this.descriptionsData.name);
      a.setAttribute("target", "_blank");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    getDetail(data) {
      getDetails(data).then((res) => {
        console.log(res, "code");
        // return;
        if (res.code == 0) {
          this.descriptionsData = res.data;
          this.descriptionsData.results = [];
          var max = this.descriptionsData.result;
          var ite = max.reduce(function (a, b) {
            return b > a ? b : a;
          });
          // console.log(ite)
          if (this.descriptionsData.risk == 0) {
            this.descriptionsData.des =
              "健康系统没有找到风险部位，请您定期做健康监测。";
            this.descriptionsData.resultStatus = 0;
          } else if (this.descriptionsData.risk == 1) {
            this.descriptionsData.des =
              "健康系统提示您，以上部位可能存在低风险，请您定期做健康检测。";
            this.descriptionsData.resultStatus = 1;
          } else if (this.descriptionsData.risk == 2) {
            this.descriptionsData.des =
              "健康系统提示您，以上部分可能存在中风险，建议您去医院进行复查。";
            this.descriptionsData.resultStatus = 2;
          } else if (this.descriptionsData.risk == 3) {
            this.descriptionsData.des =
              "健康系统提示您，以上部分可能存在高风险，建议您去医院进行复查。";
            this.descriptionsData.resultStatus = 3;
          } else if (this.descriptionsData.risk == 4) {
            this.descriptionsData.des =
              "健康系统提示您，以上部分可能存在极高风险，建议您去医院进行复查。";
            this.descriptionsData.resultStatus = 4;
          }
          this.path = this.descriptionsData.uploadPath[0];
          this.descriptionsData.uploadPath.forEach((item, index) => {
            if (index > 4) {
              return;
            } else {
              this.descriptionsData.results.push({
                id: item,
                name: this.descriptionsData.result[index],
              });
            }
          });
          this.descriptionsData.images = [
            { result: 0.5, imagesList: [] },
            { result: 0.8, imagesList: [] },
            { result: 0.9, imagesList: [] },
            { result: 1, imagesList: [] },
          ];

          this.descriptionsData.fileList = [];
          this.descriptionsData.results.forEach((ite) => {
            this.descriptionsData.fileList.push({ url: ite.id });
            if (ite.name == -1) {
              // 健康
              this.descriptionsData.images[0].imagesList.push(ite.id);
            }
            if (ite.name >= 0 && ite.name < 0.9) {
              // 低风险
              this.descriptionsData.images[1].imagesList.push(ite.id);
            }
            if (ite.name == 0.9) {
              // 中风险
              this.descriptionsData.images[2].imagesList.push(ite.id);
            }
            if (ite.name > 0.9) {
              // 高风险
              this.descriptionsData.images[3].imagesList.push(ite.id);
            }
            // if(this.descriptionsData.images[3].imagesList.length < 2){
            //   this.descriptionsData.images[2].imagesList.push(this.descriptionsData.images[3].imagesList[0])
            //   this.descriptionsData.images[2].imagesList.push(this.descriptionsData.images[3].imagesList[1])
            // }
            if (this.descriptionsData.images[1].imagesList.length > 0) {
              this.descriptionsData.images[0].imagesList = [];
            }
          });
          // if (this.$route.query.type == 2) {
          //   var str = this.descriptionsData.description[0].replace(
          //     /大小约\d+(\.\d+)?\*\d+(\.\d+)?mm，/,
          //     ""
          //   );
          //   this.descriptionsData.description[0] = str.replace(
          //     /大小约\d+(\.\d+)?\*\d+(\.\d+)?mm，/,
          //     ""
          //   );
          // }
          console.log(this.descriptionsData);
        }
      });
    },
    pdf() {
      htmlToPdf.downloadPDF(document.querySelector("#demo"), "我的PDF");
    },
  },
  mounted() {
    if (this.$route.query.id) {
      let data = {
        id: this.$route.query.id,
        projectId: this.$route.query.projectId,
      };
      this.getDetail(data);
    } else {
      // this.$router.go(-1);
      console.log(this.$route.query);
    }
    // this.src = pdf.createLoadingTask(this.pdfSrc);
    // this.src.then((pdf) => {
    //   this.numPages = pdf.numPages;
    // });
  },
};
</script>

<style>
.reportcontain {
  padding: 5px;
  padding-top: 10px;
}
/* p {
  text-indent: 2em;
} */
.my-img {
  width: 10px;
  height: 10px;
}

.my-img .el-image__inner,
.el-image__error {
  visibility: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  width: 80%;
}
.title2 {
  display: flex;
  justify-content: space-between;
  width: 70%;
}
</style>
